<!-- UI 交易组件模块化 -->
<template>
    <div>
        <!-- 买入UI -->
        <div class="ui-transaction" v-if="isSwitch">
            <div class="ui-transaction-tite">
                <div>請選擇代幣</div>
                <div>
                    <van-dropdown-menu active-color="#f19496" class="dropdwon">
                        <van-dropdown-item v-model="selectValue" :options="optionsValue" @change="uiChange" get-container="main-select"/>
                    </van-dropdown-menu>
                </div>
            </div>
            <div class="ui-balance">餘額: {{optionsValue[optionsInidex].titeCoin}}</div>
            <div>
                <div class="linear-box">
                    <div class="token-box1">
                        <div><img :src="optionsValue[optionsInidex].imgTite"><span>{{optionsValue[optionsInidex].tite}}</span></div>
                        <input type="number" v-model="moduleBuyUsdt" @focus="getV2focus()">
                    </div>
                </div>
            </div>
            <div>
                <div class="exchange">
                    <span @click="changeSell()">
                        <img :src="data.imgExchange" alt="">
                    </span>
                </div>
            </div>
            <div class="ui-balance">餘額: {{optionsValue[optionsInidex].subtitleCoin}}</div>
            <div>
                <div class="linear-box">
                    <div class="token-box1">
                        <div><img :src="optionsValue[optionsInidex].imgSubtitle"><span>{{optionsValue[optionsInidex].subtitle}}</span></div>
                        <input type="number" v-model="moduleBuyCoin" @focus="getV2focus()">
                    </div>
                </div>
            </div>
            <div class="bnb-box">
                <div><img :src="data.imgBnb">BNB：</div>
                <span>{{ data.userBnb }}</span>
            </div>
            <div class="buy-btn" v-show="!optionsValue[optionsInidex].titeApprove" @click="approve()">
                <span>暂无交易所池</span>
            </div>
            <div class="buy-btn" v-show="optionsValue[optionsInidex].titeApprove" @click="sellCkd(v1input)">
                <span>买入</span>
            </div>
        </div>
        <!-- 卖出UI -->
        <div class="ui-transaction" v-if="!isSwitch">
            <div class="ui-transaction-tite">
                <div>請選擇代幣</div>
                <div>
                    <van-dropdown-menu active-color="#f19496" class="dropdwon">
                        <van-dropdown-item v-model="selectValue" :options="optionsValue" @change="uiChange" get-container="main-select"/>
                    </van-dropdown-menu>
                </div>
            </div>
            <div class="ui-balance">餘額: {{optionsValue[optionsInidex].subtitleCoin}}</div>
            <div>
                <div class="linear-box">
                    <div class="token-box1">
                        <div><img :src="optionsValue[optionsInidex].imgSubtitle"><span>{{optionsValue[optionsInidex].subtitle}}</span></div>
                        <input type="number" v-model="moduleBuyCoin" @focus="getV2focus()">
                    </div>
                </div>
            </div>
            <div>
                <div class="exchange">
                    <span @click="changeSell()">
                        <img :src="data.imgExchange" alt="">
                    </span>
                </div>
            </div>
            <div class="ui-balance">餘額: {{optionsValue[optionsInidex].titeCoin}}</div>
            <div>
                <div class="linear-box">
                    <div class="token-box1">
                        <div><img :src="optionsValue[optionsInidex].imgTite"><span>{{optionsValue[optionsInidex].tite}}</span></div>
                        <input type="number" v-model="moduleBuyUsdt" @focus="getV2focus()">
                    </div>
                </div>
            </div>
            <div class="bnb-box">
                <div><img :src="data.imgBnb">BNB：</div>
                <span>{{ data.userBnb }}</span>
            </div>
            <div class="buy-btn" v-show="!optionsValue[optionsInidex].subtitleApprove" @click="approve()">
                <span>暂无交易所池</span>
            </div>
            <div class="buy-btn" v-show="optionsValue[optionsInidex].subtitleApprove" @click="sellCkd(v1input)">
                <span>卖出</span>
            </div>
        </div>
    </div>
</template>
<script>
export default{
    name:"TransactionUi",
    // 组件
    comments:{

    },
    props: {
    data: {
      type: Object,
      required: true // 确保父组件必须传递这个 prop
    }
  },
    data(){
        return{
            // 选择币种
            selectValue: 0,
            // 输入买入的USDT
            moduleBuyUsdt: 0,
            // 输入买入的币种
            moduleBuyCoin: 0,
            // 加载所有币种
            optionsValue: this.data.option,
            // 当前选择了第几个币
            optionsInidex:0,
            // 切换买卖
            isSwitch:true,
        }
    },
    methods:{
        // 切换买入币种
        uiChange(e){
            this.optionsInidex = e;
        },
        // 切换买卖 
        changeSell(){
            this.isSwitch = !this.isSwitch
        },
        //授权传递给父主键处理
        async approve(){
            if(this.isSwitch){
                return  this.$emit('approve', { 
                    tite: this.data.option[this.optionsInidex].tite,
                    optionsInidex:this.optionsInidex
                });
            }

            this.$emit('approve', { 
                    tite: this.data.option[this.optionsInidex].tite,
                    optionsInidex: this.optionsInidex
                })
        }
    }
}
</script>

<style scoped>
@import './style/transactionUi.css'; 
</style>